<template>
  <div class="DadosFalecimentoSV">
    <div class="row">
      <div class="col-sm-4 col-lg-3">
        <div class="form-group">
          <label class="label"
                 for="data_ocorrido">Data de Falecimento</label>
          <input id="data_ocorrido"
                 v-model="obito.registro.data_ocorrido"
                 v-validate="`date_format:yyyy-MM-dd|date_between:${ initDate },${ limitDate }`"
                 class="form-control form-control-sm"
                 :class="{ 'is-invalid': errors.has('data_ocorrido') }"
                 name="data_ocorrido"
                 placeholder="00/00/0000"
                 type="date"
                 @change="updateDateRegistro">
          <small
            v-if="errors.has('data_ocorrido')"
            class="invalid-feedback">{{ errors.first('data_ocorrido') }}</small>
        </div>
      </div>

      <div class="col-sm-4 col-lg-3">
        <div class="form-group">
          <label class="label"
                 for="hora_ocorrido">Hora de Falecimento</label>
          <input id="hora_ocorrido"
                 v-model="obito.registro.hora_ocorrido"
                 :class="{ 'is-invalid': errors.has('hora_ocorrido') }"
                 class="form-control form-control-sm"
                 name="hora_ocorrido"
                 type="time"
                 @change="updateRegistroField">
          <small v-if="errors.has('hora_ocorrido')"
                 class="invalid-feedback">{{ errors.first('hora_ocorrido') && `Hora Inválida` }}</small>
        </div>
      </div>

      <div v-if="obito.natimorto"
           class="col-sm-5 col-lg-4">
        <div class="form-group">
          <label class="label"
                 for="semanas_gestacao">Nº de semanas de duração da gestação</label>
          <div class="col-12 m-0 p-0 d-inline-flex justify-content-between">
            <div class="col-4 m-0 p-0">
              <input id="semanas_gestacao"
                     v-model="obito.semanas_gestacao"
                     :class="{ 'is-invalid': errors.has('semanas_gestacao') }"
                     class="form-control form-control-sm"
                     name="semanas_gestacao"
                     placeholder="00"
                     type="number"
                     max="55"
                     :disabled="obito.semanas_gestacao_ignorada"
                     @change="changed()">
              <small v-if="errors.has('semanas_gestacao')"
                     class="invalid-feedback">{{ errors.first('semanas_gestacao') }}</small>
            </div>

            <div class="col">
              <div class="form-group">
                <span class="custom-control custom-switch mr-4">
                  <input id="semanas_gestacao_ignorado"
                         v-model="obito.semanas_gestacao_ignorada"
                         class="custom-control-input"
                         name="semanas_gestacao_ignorado"
                         type="checkbox"
                         @change="disableSemanasGestacao"
                         @keyup.enter="changeSemanaGestacao">
                  <label class="custom-control-label"
                         for="semanas_gestacao_ignorado">Ignorado</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="SegundaViaObito_body_header mb-2">
          Local de Ocorrência
        </div>
      </div>
      <div class="col-12">
        <LocalOcorrencia :local-ocorrencia="obito.registro.local"
                         :endereco-falecido="checkEnderecoFalecido()"
                         :read-only="true"
                         @changed="getLocalOcorrencia" />
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <div class="SegundaViaObito_body_header mb-2">
          Causas de Óbito
        </div>
      </div>
      <div class="col-12">
        <CausaObito :data="obito"
                    :prop-natimorto="!!obito.natimorto"
                    :hide-header="true"
                    @changed="getCausaObito" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="SegundaViaObito_body_header mb-2">
          Médico
        </div>
      </div>
      <div class="col-12">
        <Medicos :lista-medicos="obito.medicos"
                 :read-only="true"
                 @medicoUpdated="medicoUpdated"
                 @medicoRemoved="removeMedico" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="SegundaViaObito_body_header mb-2">
          Sepultamento
        </div>
      </div>
      <div class="col-12 mt-2">
        <Sepultamento :prop-sepultamento="obito.sepultamento"
                      :prop-sepultamento-id="obito.sepultamento_id"
                      :prop-sepultamento-certidao="obito.sepultamento_certidao"
                      :prop-edit="!!obito.sepultamento"
                      @changed="getLocalSepultamento"
                      @onRemoveSepultamento="removeSepultamento"
                      @newSepultamento="getLocalSepultamento" />
      </div>
    </div>
  </div>
</template>

<script>
  //components
  import CausaObito from '@/components/SofiaRei/Obito/Passos/Sessoes/CausaObito'
  import LocalOcorrencia  from '@/components/SofiaRei/Obito/SegundaVia/LocalOcorrenciaObitoSV.vue'
  import Medicos from '@/components/SofiaRei/Obito/SegundaVia/MedicosSV.vue'
  import Sepultamento from '@/components/SofiaRei/Obito/SegundaVia/SepultamentoSV.vue'

  //outros
  import moment from 'moment'

  export default {
    name: 'DadosFalecimentoSV',
    components: {
      LocalOcorrencia,
      Medicos,
      CausaObito,
      Sepultamento
    },
    props: {
      propObito: { type: Object, default: null}
    },
    inject: ['$validator'],
    data () {
      return {
        selectsOptions: {
          causasMorte: [],
          funerarias: []
        },
        initDate: moment('1500-01-01').format('YYYY-MM-DD'),
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        obito: {
          registro: {}
        }
      }
    },
    watch: {
      propObito () {
        this.obito = { ...this.propObito }
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.obito = { ...this.propObito }

        if (!!this.obito.registro.pessoa.data_nascimento) {
          this.initDate = moment(this.obito.registro.pessoa.data_nascimento, 'DD/MM/YYYY').add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      async updateDateRegistro () {
        if (this.obito.registro.data_ocorrido === '') {
          this.obito.registro.data_ocorrido = null
        }
        
        this.changed()
      },

      async updateRegistroField (event) {
        let data = {[event.target.name]: event.target.value }
        if (this.obito.registro.hora_ocorrido === '') {
          this.obito.registro.hora_ocorrido = null
        }
        if (data.hora_ocorrido === '') {
          data.hora_ocorrido = null
        }

        this.changed()
      },
      async updateObitoField (event) {
        let data = {[event.target.name]: event.target.value }

        
        this.changed()
      },
      getLocalOcorrencia (localOcorrencia) {
        if (!Object.entries(localOcorrencia.localOcorrencia).length) {
          this.obito.registro.local_ocorrencia_id = null
        }

        this.obito.registro.localOcorrencia = localOcorrencia.localOcorrencia
        this.obito.registro.local = localOcorrencia.localOcorrencia

        this.changed()
      },
      async getCausaObito (causaObito) {
        this.obito = { 
          ...this.obito,
          ...causaObito,
          causaObito: {
            ...causaObito
          }
        }

        this.changed()
      },
      getLocalSepultamento (sepultamento) {
        // passando sepultamento_certidao para local original e excluindo de objeto
        this.obito.sepultamento_certidao = sepultamento.sepultamento_certidao

        this.obito.sepultamento_id = !!sepultamento.sepultamento_id ? sepultamento.sepultamento_id : null
        this.obito.sepultamento = sepultamento

        this.$emit('changed', this.obito)
      },
      removeSepultamento () {
        this.obito.sepultamento = null
        this.obito.sepultamento_id = null
        this.obito.sepultamento_certidao = null
        this.$emit('changed', this.obito)
      },
      updateFuneraria (objUpdate) {
        this.obito.numero_declaracao_funeraria = objUpdate.numero_declaracao_funeraria
        this.obito.showEndereco = objUpdate.showEndereco
        this.obito.funeraria_id = objUpdate.funeraria_id
        this.obito.funeraria = objUpdate.funeraria
        this.obito.convenio_funeraria = objUpdate.convenio_funeraria

        this.changed()
      },
      removeMedico (medico) {
        this.obito.medicos = this.obito.medicos.filter((med) => med.crm !== medico.crm )
        this.$emit("medicoRemoved", medico)
        this.changed()
      },
      medicoUpdated (medico, localId) {
        this.obito.medicos[localId] = medico
        this.changed()
      },
      changed () {
        this.$emit('changed', this.obito)
      },
      checkEnderecoFalecido () {
        const { pessoa, enderecos } = this.obito

        //pega o endereco do registrado ao cadastrar registro
        if (enderecos && enderecos.length) return this.obito.enderecos[0]

        //pega o endereco do registrado ao editar registro
        else if (pessoa && pessoa.enderecos && pessoa.enderecos.length) return this.obito.pessoa.enderecos[0]

        else return {}
      },
      disableButton () {
        const btn = document.querySelector('.btn-add-local')

        if (btn) {
          btn.setAttribute('disabled', true)

          setTimeout(() => {
            btn.removeAttribute('disabled')
          })
        }
      },
      disableSemanasGestacao () {
        if (!!this.obito.semanas_gestacao_ignorada) this.obito.semanas_gestacao = 0
        else this.obito.semanas_gestacao = null

        this.changed()
      },
      changeSemanasGestacao () {
        this.obito.semanas_gestacao_ignorada = !this.obito.semanas_gestacao_ignorada

        this.disableSemanasGestacao()
      },
    }
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/exports';

  .dadosFalecimBox {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_error {
        color: #8B0000;
      }
    }
  }
</style>